import { MenuConfigModel } from '@core/models/outros/menu-config.model';
import { UserTypeEnum } from '@enums/user-type.enum';
import { ApplicationModules } from '@enums/application-modules.enum';

//item de menu utilizado para fazer o menu do usuário (header)
export const MENU_USER_SETTINGS: MenuConfigModel = {
  id: ApplicationModules.USER_SETTINGS,
  icon: 'account_circle',
  name: 'Configurações de Usuário',
  onlyAssociated: true,
  disabled: true,
  profilesToShowItems: [
    UserTypeEnum.ADMINISTRADOR,
    UserTypeEnum.OPERADOR_N1,
    UserTypeEnum.INSTRUTOR,
    UserTypeEnum.SUPERVISOR,
    UserTypeEnum.ADMINISTRADOR_DETRAN
  ],
  submenus: [],
}
